module.exports = __webpack_public_path__ + "static/media/Run-Campaign.7697a7e6.jpg";